<template>
  <div class="ws-participants__item-info">
    <ws-role-node
      :only="[
        'front_curator',
        'front_curator_institution',
        'front_dep',
        'front_admin'
      ]"
    >
      <b-upload
        v-if="!file"
        v-model="file"
        @input="uploadFile"
        class="is-fullwidth"
      >
        <span
          class="ws-button button is-fullwidth upload-file__upload"
          :class="{ 'is-loading': isPending }"
        >
          Загрузить согласие на обработку ПД
        </span>
      </b-upload>
    </ws-role-node>
    <div class="upload-file" v-if="file">
      <div class="upload-file__right">
        <div class="upload-file__title has-text-success has-text-weight-bold">
          <span>Загружен</span>
          <button
            type="button"
            class="ws-button file-download-button button is-text is-small is-size-4 has-text-left"
            @click.stop="openFile"
          >
            <span
              class="file-download-button__file-name upload-file__name has-text-primary"
              v-if="true"
            >
              <strong>{{ file.file_name || "-" }}</strong>
            </span>
          </button>
        </div>
        <div class="upload-file__footer">
          <p class="upload-file__size has-text-primary">
            {{ prettyBytes(file.file_size || 0) }}
          </p>
          <p class="upload-file__date">
            <ws-time-formatter
              :date="file.created_at"
              format="DD.MM.YYYY HH:MM"
            />
          </p>
        </div>
      </div>
      <button @click="toRemove" type="button" class="upload-file__delete">
        <ws-icon name="trash" color="dark" width="16" height="16" />
      </button>
    </div>
  </div>
</template>

<script>
import prettyBytes from '../../../filters/prettyBytes'
import { downloadFileUrl } from '@/utils/helpers'
import axios from 'axios'

export default {
  name: 'WsParticipantsPersonalData',
  props: {
    userInfo: Object,
    changeUserAgreement: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      file: null,
      isPending: false
    }
  },
  watch: {
    file: {
      immediate: true,
      handler (val) {
        let isUserAgreement = false
        if (val) {
          isUserAgreement = true
        }
        this.changeUserAgreement(isUserAgreement)
      }
    }
  },
  async created () {
    await this.getPersonalAgreement()
  },
  methods: {
    prettyBytes,
    async uploadFile (file) {
      this.isPending = true
      const formData = new FormData()
      formData.append('file', file, file.filename)

      try {
        const url = `${__config.api_url}/api/dpws/profile/${
          this.userInfo.guid
        }/files/add/category/user-agreement-doc/${this.userInfo.guid}`
        const { data } = await axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        this.file = data.data[0]

        this.$buefy.toast.open({
          message: this.$t('Файл успешно загружен'),
          type: 'is-success'
        })
      } catch {
        this.$buefy.toast.open({
          message: this.$t('Ошибка загрузки документа'),
          type: 'is-danger'
        })
      }
      this.isPending = false
    },
    async openFile () {
      if (this.disabled) return
      this.isOpeningFile = true
      try {
        const url = `${__config.api_url}/api/dpws/profile/${
          this.userInfo.guid
        }/files/file/${this.file.guid}?json=true`
        const { data: { data: file } } = await axios.get(url)

        if (file && file.redirect_to) {
          downloadFileUrl(file.redirect_to, this.file.file_name)
        }
      } catch (e) {
        this.$buefy.toast.open({
          message: 'Ошибка скачивания файла',
          type: 'is-danger',
          duration: 5000
        })
      }
      this.isOpeningFile = false
    },
    async getPersonalAgreement () {
      const url = `${__config.api_url}/public/profile/${
        this.userInfo.guid
      }/files/category/user-agreement-doc/${this.userInfo.guid}`
      try {
        const { data } = await axios.get(url)
        if (data.data && data.data[0]) {
          this.file = data.data[0]
        } else {
          this.file = null
        }
      } catch {
        this.file = null
        this.$buefy.toast.open({
          message: this.$t(`Ошибка получения согласия на обработку ПД`),
          type: 'is-danger',
          duration: 5000
        })
      }
    },
    async toRemove () {
      const url = `${__config.api_url}/api/dpws/profile/${
        this.userInfo.guid
      }/files/file/${this.file.guid}`
      const res = await axios.delete(url)
      if (!res.error) {
        this.$buefy.notification.open({
          type: 'is-success',
          message: 'Файл удален'
        })
        await this.getPersonalAgreement()
      } else {
        this.file = null
        this.$buefy.notification.open({
          type: 'is-danger',
          message: 'Ошибка удаления файла'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.file-download-button {
  height: fit-content;
  overflow: hidden;
}

.upload-file {
  padding: 5px;
  border-radius: 4px;
  background-color: #fff;
  margin-right: 40px;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;

  &__delete {
    background-color: transparent;
    border: none;
    padding: 4px;
    cursor: pointer;
  }

  &__right {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  &__upload {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  &__title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }

  &__name {
    margin-left: 3px;
    text-decoration-line: underline;
    height: fit-content;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__date {
    overflow: hidden;
    color: #979797;
    text-align: right;
    text-overflow: ellipsis;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
</style>
